import gql from 'graphql-tag';

export const FRAGMENT_CALENDAR_PERIOD = gql`
  fragment calendarPeriod on CalendarPeriod {
    periodFrom
    periodTo
  }
`;
